import moment from 'moment'

const d = new Date()
const todaysDate = moment(new Date(d), 'YYYY-MM-DD')
const d2 = d.setMonth(d.getMonth() - 6)
const pastSixMonths = moment(new Date(d2), 'YYYY-MM-DD')

export { todaysDate, pastSixMonths }
